import "lazysizes"
import $ from "cash-dom"
import Rails from "@rails/ujs"
import Cookies from "js-cookie"

window.$ = $
window.Rails = Rails
Rails.start()
window.Cookies = Cookies
